export default {
  getOptions (options) {
    let result = this.translateData(options.data)
    let data = result.data
    return {
      color: ['#4fc3f7', '#e57373', '#ffd54f', '#81c784', '#9575cd', '#4db6ac', '#ffb74d', '#4dd0e1'],
      // 点击饼图显示信息
      tooltip: Object.assign({
        trigger: 'item',
        padding: 10,
        backgroundColor: 'rgba(61, 61, 61, 0.95)',
        extraCssText: 'box-shadow: 0 4px 9px rgba(0, 0, 0, 0.3); border-radius: 8px;',
        formatter: '{b}:{c}' + (options.config.unit || '件') + '({d}%)',
        confine: true
      }, options.config.tooltip),
      // 图例
      legend: Object.assign({
        orient: 'vertical',
        left: options.config.legendLeft || '60%',
        top: options.config.legendTop || 'middle',
        data: data,
        icon: 'circle',
        itemHeight: 10,
        itemWidth: 10,
        borderRadius: '50%',
        itemGap: options.config.itemGap,
        formatter: function (name) {
          var value = 0
          data.forEach(function (item) {
            if (item.name === name) {
              value = item.value
            }
          })
          var percent = (value * 100 / result.total)
          if (percent < 0.01) {
            percent = 0.01
          }
          var ary = [
            '{a|' + name + '}',
            '{b|' + value + '件}' + '{c|' + percent.toFixed(2) + '%}'
          ]
          if (options.config.legendIsJ) {
            var legendLineSpliter = options.legendLineSpliter === '' ? '' : ' '
          } else {
            legendLineSpliter = options.legendLineSpliter === '' ? '' : '\n'
          }
          return ary.join(legendLineSpliter)
        },
        textStyle: options.config.legendTextStyle || {
          rich: {
            a: {
              fontSize: 12,
              color: '#4a4a4a',
              fontWeight: 500,
              padding: [0, 0, 15, 0]
            },
            b: {
              fontSize: 12,
              color: '#737373',
              padding: [0, 10, 5, 0]
            },
            c: {
              fontSize: 12,
              color: '#a9a9a9',
              padding: [0, 0, 5, 0]
            }
          }
        }
      }, options.config.legend),
      series: [{
        name: options.name,
        type: 'pie',
        itemStyle: {
          normal: {
            borderColor: '#fff',
            borderWidth: data.length > 1 ? 1 : 0
          },
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 5,
            shadowColor: 'rgba(0, 0, 0, 0.06)'
          }
        },
        radius: options.config.radius || ['37%', '50%'],
        center: options.config.seriesCenter || ['32%', '50%'],
        label: {
          normal: {
            show: false
          }
        },
        data: data
      }]
    }
  },

  /**
   * 转换原始数据，用description显示
   * @param {Object} data 图表原始数据
   * @return {Object}     处理后的数据
   */
  translateData (data) {
    let total = 0
    data = data.map(item => {
      total += parseFloat(item.value, 10)
      item.name = item.description
      return item
    })
    return {
      total,
      data
    }
  }
}
